import PropTypes from "prop-types";
import React, {Component} from "react";
import ButtonBase from '@material-ui/core/ButtonBase';
import TweenMax from "gsap/TweenMaxBase";
import {Container, Text} from "./index";
import Transition from "react-transition-group/Transition";
import {di} from "../bottle";


// class definition
export class InfoCard extends Component {

    static propTypes = {
        style: PropTypes.any,
        show: PropTypes.bool.isRequired,
        title: PropTypes.string.isRequired,
        priceString: PropTypes.string.isRequired,
        description: PropTypes.string.isRequired,
        onClose: PropTypes.func,
    };

    static defaultProps = {
        show: false,
        title: "Title",
        priceString: "No price available",
        description: "Description",
        onClose: () => undefined
    };

    constructor(props) {
        // call base constructor
        super(props);

        // initialize instance variables
        this.animator = null;
    }

    onClosePressed = () => {
        this.animator.reverse();
    };

    render() {

        // resolve properties
        const {style, show, title, priceString, description, onClose ,isExcluded} = this.props;
        const hidePrice = di.profileManager.hidePrice()


        // render view
        return (
            <Transition
                timeout={1}
                mountOnEnter
                unmountOnExit
                in={show}
                addEndListener={(node, done) => {
                    const onComplete = () => {
                        this.setState({
                            visible: true
                        })
                    };
                    const onReverseComplete = () => {
                        this.setState({
                            visible: false
                        });
                        onClose();
                    };
                    this.animator = TweenMax.from(node, 0.7, {
                        autoAlpha: 0,
                        y:"-=50",
                        onComplete: onComplete,
                        onReverseComplete: onReverseComplete
                    })
                }}
            >
                <Container style={styles.container}>
                    <Container
                        flex
                        justify="center"
                        alignItems="center"
                        style={{ height: "inherit", ...style}}>
                        <Container style={styles.innerContainer}>
                            <Text style={styles.title} bold uppercase>
                                {title}
                            </Text>
                            { (!isExcluded && !hidePrice) &&
                                <Text style={styles.price} bold uppercase>
                                    {priceString}
                                </Text>    
                            }
                            <Text style={styles.description}>
                                {description}
                            </Text>
                            <ButtonBase onClick={this.onClosePressed} style={styles.button}>
                                <Text style={styles.buttonText} bold uppercase>
                                    {di.localization.get("common.close")}
                                </Text>
                            </ButtonBase>
                        </Container>
                    </Container>
                </Container>
            </Transition>
        );
    }
}

const styles = {

    container: {
        position: "absolute",
        width: "100%",
        height: "101%",
        zIndex: 10,
        userSelect: "none"
    },
    innerContainer: {
        backgroundColor: "#161616",
        width: "100%",
        height: "100%",
        padding: 40,
        position: "relative",
    },
    title: {
        color: "#ffffff",
        fontSize: 40,
    },
    price: {
        color: "#ffffff",
        fontSize: 24,
    },
    description: {
        color: "#ffffff",
        fontWeight: 100,
        paddingTop: 20,
    },
    button: {
        position: "absolute",
        bottom: 0,
        right: 0,
        padding: 34
    },
    buttonText: {
        fontSize: 24,
        color: "#9b9b9b"
    }
};


// WEBPACK FOOTER //
// ./src/components/InfoCard.js